module.exports = __webpack_public_path__ + "img/carpark.80715b5a.svg";